import React from 'react';
import styled, { css } from 'styled-components';
import { Margin } from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'i18n';
import PrimaryButton from 'components/buttons/primaryButton/PrimaryButton';
import { mediaQueries } from 'styles/utils/mediaQueries';

function SummaryButtonComponent({ simple, styles, buttonMessage, onClick, airlineWhitelabel }) {
  if (simple) {
    return (
      <RootSimple styles={styles}>
        <PrimaryButton onClick={onClick}>
          <FormattedMessage {...buttonMessage} />
        </PrimaryButton>
      </RootSimple>
    );
  }

  return (
    <Root styles={styles}>
      <PrimaryButton fullWidth onClick={onClick} data-test='summary-button'>
        <ButtonContent airlineWhitelabel={airlineWhitelabel}>
          <FormattedMessage {...buttonMessage} />
          <Margin right='0.5' inline />
          <FontAwesomeIcon icon='arrow-right' />
        </ButtonContent>
      </PrimaryButton>
    </Root>
  );
}

export default SummaryButtonComponent;

const RootSimple = styled.div`
  max-width: 120px;

  ${({ styles }) =>
    styles &&
    css`
      ${styles}
    `}
`;

const Root = styled.div`
  display: block;
  width: 100%;
  text-align: center;

  ${mediaQueries.fromAndAbove.desktop`
    margin-bottom: 20px;
  `}

  ${({ styles }) =>
    styles &&
    css`
      ${styles}
    `}
`;

const ButtonContent = styled.div`
  font-size: 2.2em;
  font-weight: ${({ airlineWhitelabel }) => (airlineWhitelabel && airlineWhitelabel.isAirBaltic ? 500 : 'inherit')};
`;
